export default __webpack_public_path__ + "static/media/Graphik-Regular.97a556b5.woff2";